<template>
  <div class="bg-lightblue text-white  rounded-full  px-3 xl:px-3 py-1 tracking-wider font-display uppercase leading-none">
    <slot />
  </div>
</template>
